<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        icon="el-icon-plus"
        @click="open('add')"
      >添加</el-button>
      <el-button
        type="danger"
        size="mini"
        icon="el-icon-delete"
        @click="bulkDelete"
      >删除</el-button>
      <el-button
        type="success"
        size="mini"
        icon="el-icon-refresh"
        @click="getList()"
      >刷新</el-button>
    </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="showtabelData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      style="width: 1311px"
      height="calc(100vh - 240px )"
      size="mini"
      row-key="id"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50" />
      <el-table-column prop="sort" label="排序" width="80" class="sort" />
      <el-table-column prop="imgUrl" label="图片" width="260">
        <template slot-scope="scope">
          <el-image
            :src="scope.row.imgUrl"
            fit="contain"
            style="width: 50px; height: 50px"
            :preview-src-list="toArrayEvent(scope.row.imgUrl)"
          />
        </template>
      </el-table-column>
      <el-table-column prop="title" label="文章标题" width="200" />
      <el-table-column label="有效上架时间" width="300">
        <template slot-scope="scope">
          {{ scope.row.effectiveStartTime }} ~ {{ scope.row.effectiveEndTime }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="220">
        <template slot-scope="scope">
          {{
            $parseTime(new Date(scope.row.createdAt), "{y}-{m}-{d} {h}:{i}:{s}")
          }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="open('edit', scope.row)"
          >修改</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加编辑弹窗 -->
    <el-dialog
      :title="isEdit ? '修改' : '添加'"
      :visible.sync="dialogVisible"
      width="1200px"
      :close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="formData" label-width="220px" size="mini">
        <el-form-item label="图片">
          <uploadPic
            ref="uploadPic"
            :my-url="formData.imgUrl"
            :width="80"
            :height="80"
            @upLoadImage="upLoadImage"
          />
        </el-form-item>
        <el-form-item label="有效上架时间">
          <el-date-picker
            v-model="effectiveTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
        <el-form-item label="文章标题">
          <el-input
            v-model="formData.title"
            placeholder="请输入文章标题"
            style="width: 200px"
            size="mini"
          />
        </el-form-item>
        <el-form-item label="文章内容">
          <vue-ueditor-wrap
            v-model="formData.content"
            :config="config"
            class="ueditor"
          />
        </el-form-item>
        <el-form-item label="排序序号">
          <el-input-number v-model="formData.sort" :min="1" />
        </el-form-item>
        <el-form-item>
          <el-button
            style="margin-right: 10px"
            @click="dialogVisible = false"
          >取消</el-button>
          <el-popconfirm
            title="确定添加？"
            @onConfirm="isEdit ? edit() : add()"
          >
            <el-button
              slot="reference"
              type="primary"
              class="edit-button"
            >保存</el-button>
          </el-popconfirm>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import uploadPic from '@/components/Upload/UploadPic' // 引入单图片上传组件
import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module

import environment from '@/utils/environment'
// Default SortableJS
import Sortable from 'sortablejs'
import {
  getBannerList,
  addBanner,
  updateBanner,
  sortBanner,
  removeBanner
} from '@/api/banner.js'
import { getList } from '@/api/androidVersion'
import { parseTime } from '@/utils'
export default {
  name: 'Order',
  components: { uploadPic, VueUeditorWrap },
  data() {
    return {
      loading: false,
      total: 0,
      showtabelData: [], // 表单数据
      multipleSelection: [], // 选中项
      dialogVisible: false, // 弹窗标识
      formData: {
        title: '',
        effectiveStartTime: '',
        effectiveEndTime: '',
        imgUrl: '',
        sort: ''
      }, // 选中项
      effectiveTime: [],
      isEdit: false,
      config: {
        UEDITOR_HOME_URL: '/ueditor/', // 需要令此处的URL等于对应 ueditor.config.js 中的配置。服务器
        autoHeightEnabled: false,
        initialFrameHeight: 500,
        initialFrameWidth: 700,
        maximumWords: 9999999,
        // 上传文件接口
        serverUrl: '/gw/admin/operate/uploadBanner',
        headers: { Authorization: localStorage.getItem('token') },
        imageActionName: 'uploadimage',
        imageAllowFiles: ['.png', '.jpg', '.jpeg', '.gif', '.bmp'],
        imageUrlPrefix: '' /* 图片访问路径前缀 */,
        imagePathFormat: '',
        imageMaxSize: 1024 * 1000 * 10, // 单位B 10MB
        toolbars: [
          [
            'fullscreen',
            'source',
            '|',
            'undo',
            'redo',
            '|',
            'bold',
            'italic',
            'underline',
            'fontborder',
            'strikethrough',
            'removeformat',
            '|',
            'forecolor',
            'backcolor',
            'insertorderedlist',
            'insertunorderedlist',
            '|',
            'paragraph',
            'fontfamily',
            'fontsize',
            '|',
            'justifyleft',
            'justifycenter',
            'justifyright',
            'justifyjustify',
            '|',
            // "simpleupload",
            'insertimage',
            'emotion',
            '|',
            'link',
            'unlink'
          ]
        ]
      },
      sortable: null
    }
  },
  mounted() {
    this.getList()
    this.columnDrop()
  },
  beforeDestroy() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  },
  methods: {
    toArrayEvent(item) {
      return [item]
    },
    // 图片上传回调
    upLoadImage(url) {
      console.log(url, 'url...')
      this.formData.imgUrl = url
    },
    // 获取表单信息
    getList() {
      this.loading = true
      getBannerList()
        .then((res) => {
          this.showtabelData = res
          this.total = res.total
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 选择或者取消行，支持全选
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 关闭添加弹窗
    handleClose() {
      this.initData = {}
    },
    initData() {
      this.formData = {
        title: '',
        effectiveStartTime: '',
        effectiveEndTime: '',
        imgUrl: '',
        sort: ''
      }
    },
    open(type, item) {
      console.log(type, item)
      this.initData()
      this.effectiveTime = []
      if (type == 'add') {
        this.isEdit = false
        setTimeout(() => {
          this.$refs.uploadPic.init('')
        }, 0)
        this.dialogVisible = true
      } else if (type == 'edit') {
        this.isEdit = true
        this.formData = { ...this.formData, ...item }
        this.effectiveTime = [
          this.formData.effectiveStartTime,
          this.formData.effectiveEndTime
        ]
        this.dialogVisible = true
      }
    },
    // 添加
    add() {
      const [startTime, endTime] = this.effectiveTime
      this.formData.effectiveStartTime = parseTime(
        startTime,
        '{y}-{m}-{d} {h}:{i}:{s}'
      )
      this.formData.effectiveEndTime = parseTime(
        endTime,
        '{y}-{m}-{d} {h}:{i}:{s}'
      )
      console.log(this.formData)
      addBanner(this.formData)
        .then((res) => {
          this.getList()
          this.dialogVisible = false
          this.$message.success('添加成功')
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },
    // 修改
    edit() {
      const [startTime, endTime] = this.effectiveTime
      this.formData.effectiveStartTime = parseTime(
        startTime,
        '{y}-{m}-{d} {h}:{i}:{s}'
      )
      this.formData.effectiveEndTime = parseTime(
        endTime,
        '{y}-{m}-{d} {h}:{i}:{s}'
      )
      updateBanner(this.formData)
        .then((res) => {
          this.getList()
          this.dialogVisible = false
          this.$message.success('修改成功')
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },
    columnDrop() {
      const that = this
      that.$nextTick(() => {
        const plxTable = that.$refs.gridTable
        that.sortable = new Sortable(
          plxTable.$el.querySelector('.el-table__body tbody'),
          {
            animation: 150,
            handle: '.el-table__row',
            onStart: function(/** Event*/ evt) {
              console.log('拖拽开始', evt)
            },
            onEnd: function({ newIndex, oldIndex }) {
              console.log('拖拽结束')
              const currRow = that.showtabelData.splice(oldIndex, 1)[0]
              that.showtabelData.splice(newIndex, 0, currRow)
              console.log(that.showtabelData, 'that.showtabelData')
              const newArr = []
              that.showtabelData.forEach((item, index) => {
                item.sort = index + 1
                newArr.push({
                  id: item.id,
                  sort: index + 1
                })
              })
              sortBanner(newArr)
                .then((res) => {
                  that.$message.success('排序成功')
                })
                .catch((err) => {
                  that.$message.error(err)
                })
            }
          }
        )
      })
    },
    // 批量删除
    bulkDelete() {
      console.log(this.multipleSelection, 'this.multipleSelection')
      if (this.multipleSelection.length > 0) {
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          roundButton: true
        })
          .then(() => {
            const ids = this.multipleSelection.map((item) => {
              return item.id
            })
            removeBanner({ ids })
              .then((res) => {
                this.$message.success('删除成功')
                this.getList()
              })
              .catch((err) => {
                this.$message.error(err)
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      } else {
        this.$message.warning('请勾选要删除的选项')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.head_search {
  display: flex;
  // justify-content: space-around;
  width: 100%;
  .item_warp {
    display: flex;
    .el-checkbox {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 20px;
    }
    span {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #525252;
    }
  }
}
.role_warp {
  font-size: 14px;
  padding: 20px;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
.isSyn {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
